import React from 'react';
import { Page, PageBlock } from 'braid-design-system';
import TopBar from '../components/TopBar';
import MenuBar from '../components/MenuBar';
import SiteFooter from '../components/SiteFooter';
import FabButton from '../components/FabButton';

export const MainLayout = ({ children }: { children: React.ReactNode }) => {
    // Scroll to top and refresh layout when route changes
    return (
        <Page
            footer={
                <SiteFooter />
            }
        >
            <TopBar />
            <MenuBar />
            <PageBlock width="full">
                {children}
            </PageBlock>
            <FabButton />

        </Page>
    );
};

export default MainLayout;
